/**
 * Flair Rugs — panier
 * - bandeau livraison offerte (progression) + date de livraison unique
 * - suppression d'un article avec « Annuler »
 * S'appuie sur Impulse sans modifier theme.js :
 *   écoute  : cart:updated, ajaxProduct:added
 *   déclenche : cart:build (reconstruction du panier par Impulse), cart:updated
 */
(function () {
  'use strict';

  var HOLIDAYS = ['1-1', '5-1', '5-8', '7-14', '8-15', '11-1', '11-11', '12-25'];
  var JSON_HEADERS = { 'Content-Type': 'application/json', Accept: 'application/json' };

  function money(cents) {
    return theme.Currency.formatMoney(cents, theme.settings.moneyFormat);
  }

  function post(url, body) {
    return fetch(url, { method: 'POST', credentials: 'same-origin', headers: JSON_HEADERS, body: JSON.stringify(body) })
      .then(function (r) { return r.json(); });
  }

  function getCart() {
    return fetch(theme.routes.cart, { credentials: 'same-origin' }).then(function (r) { return r.json(); });
  }

  function rebuild(cart) {
    document.dispatchEvent(new CustomEvent('cart:build'));
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
  }

  /* ---------- Bandeau livraison ---------- */

  function addBusinessDays(n) {
    var d = new Date();
    while (n > 0) {
      d.setDate(d.getDate() + 1);
      var off = d.getDay() === 0 || d.getDay() === 6 || HOLIDAYS.indexOf((d.getMonth() + 1) + '-' + d.getDate()) > -1;
      if (!off) n--;
    }
    return d;
  }

  function renderDate(bar) {
    var el = bar.querySelector('[data-flair-bar-date]');
    if (!el) return;
    var loc = bar.dataset.locale || 'fr';
    var f1 = new Intl.DateTimeFormat(loc, { weekday: 'short', day: 'numeric' });
    var f2 = new Intl.DateTimeFormat(loc, { weekday: 'short', day: 'numeric', month: 'short' });
    el.innerHTML = bar.dataset.delivery
      .replace('[start]', f1.format(addBusinessDays(+bar.dataset.min)))
      .replace('[end]', f2.format(addBusinessDays(+bar.dataset.max)));
  }

  function renderBar(cart) {
    var bar = document.getElementById('FlairShippingBar');
    if (!bar || !cart || typeof cart.total_price !== 'number') return;
    var text = bar.querySelector('[data-flair-bar-text]');
    var fill = bar.querySelector('[data-flair-bar-fill]');
    if (!text || !fill) return;
    var threshold = +bar.dataset.threshold;
    var remaining = threshold - cart.total_price;
    bar.classList.toggle('is-unlocked', remaining <= 0);
    text.innerHTML = remaining > 0
      ? bar.dataset.remaining.replace('[amount]', money(remaining))
      : bar.dataset.unlocked;
    var pct = threshold > 0 ? Math.min(100, Math.floor(cart.total_price * 100 / threshold)) : 100;
    fill.style.width = pct + '%';
  }

  function onCartChange(evt) {
    var cart = evt && evt.detail && evt.detail.cart;
    if (cart && typeof cart.total_price === 'number') renderBar(cart);
    else getCart().then(renderBar);
  }

  /* ---------- Suppression + annulation ---------- */

  var lastRemoved = null;
  var toastTimer = null;

  function toast() { return document.querySelector('[data-flair-toast]'); }

  function hideToast() {
    var t = toast();
    if (t) t.hidden = true;
    clearTimeout(toastTimer);
  }

  function showToast(title) {
    var t = toast();
    if (!t) return;
    t.querySelector('[data-flair-toast-text]').textContent = t.dataset.template.replace('[title]', title);
    t.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { hideToast(); lastRemoved = null; }, 5000);
  }

  function removeLine(btn) {
    var line = btn.closest('.cart__item');
    if (line) line.classList.add('is-removing');
    var props = {};
    try { props = JSON.parse(btn.dataset.properties || '{}') || {}; } catch (e) {}
    lastRemoved = { id: +btn.dataset.variantId, quantity: +btn.dataset.quantity, properties: props };

    post(theme.routes.cartChange, { id: btn.dataset.key, quantity: 0 })
      .then(function (cart) { rebuild(cart); showToast(btn.dataset.title); })
      .catch(function () { if (line) line.classList.remove('is-removing'); lastRemoved = null; });
  }

  function undoRemove() {
    if (!lastRemoved) return;
    var item = lastRemoved;
    lastRemoved = null;
    hideToast();
    post(theme.routes.cartAdd, { items: [item] }).then(getCart).then(rebuild);
  }

  document.addEventListener('click', function (evt) {
    var removeBtn = evt.target.closest('[data-flair-remove]');
    if (removeBtn) { evt.preventDefault(); removeLine(removeBtn); return; }
    if (evt.target.closest('[data-flair-undo]')) { evt.preventDefault(); undoRemove(); }
  });

  /* ---------- Init ---------- */

  document.addEventListener('cart:updated', onCartChange);
  document.addEventListener('ajaxProduct:added', onCartChange);

  var bar = document.getElementById('FlairShippingBar');
  if (bar) renderDate(bar);
})();
